import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch } from 'vue';
  import { v4 as uuidv4 } from 'uuid';
  import { useRouter } from 'vue-router/composables';
  import { t } from '@/ui/i18n/i18n';
  import AiChatTextArea from './AiChatTextArea.vue';
  import AiChatMessages from './AiChatMessages.vue';
  import type { ChatMessage } from './types';
  import AiChatPredefinedMessages from './AiChatPredefinedMessages.vue';
  import { sendMessage } from '@/services/api/resources/aiChat';
  import { useTask } from '@/ui/concerns';
  import { scrollToBottomDelayed } from '@/ui/helpers';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { hasAiBalance as hasAiBalanceComputed } from '@/ui/auth/auth';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AnalyticsAiChatPage',
  setup(__props) {

  const router = useRouter();

  const chatInput = ref('');
  const messages = ref<ChatMessage[]>([]);

  const truncateMessages = (messages: ChatMessage[]): string[] => {
    const maxMessages = 20;
    const maxCharacters = 2000;

    const recentMessages = messages
      .slice(-maxMessages)
      .map(msg => msg.content);

    const truncatedMessages = [];
    let currentChars = 0;

    for (const message of recentMessages) {
      if (currentChars + message.length > maxCharacters) {
        break;
      }
      truncatedMessages.push(message);
      currentChars += message.length;
    }

    return truncatedMessages;
  };

  const sendMessageTask = useTask(
    (query?: string) => {
      const truncatedMessages = truncateMessages(messages.value);
      return sendMessage(query || '', truncatedMessages);
    },
    response => {
      const aiMessage: ChatMessage = {
        id: uuidv4(),
        content: (response.data && response.data.human_response) || t('ai.no-response-available'),
        timestamp: new Date(),
        isUser: false,
      };
      messages.value.push(aiMessage);
    },
    'sendMessage',
    (error: any) => {
      console.error('Failed to send message:', error);

      const errorMessage: ChatMessage = {
        id: uuidv4(),
        content: t('ai.error-processing-message'),
        timestamp: new Date(),
        isUser: false,
      };
      messages.value.push(errorMessage);
    },
  );

  const handleSendMessage = (message: string) => {
    const userMessage: ChatMessage = {
      id: uuidv4(),
      content: message,
      timestamp: new Date(),
      isUser: true,
    };
    messages.value.push(userMessage);
    chatInput.value = '';
    scrollToBottomDelayed();

    sendMessageTask.run(message);
  };

  watch(() => messages.value.length, () => {
    scrollToBottomDelayed();
  });

  const isLoading = computed(() => 'pending' in sendMessageTask.state.value && sendMessageTask.state.value.pending);

  const goBack = () => {
    router.push({ name: 'analytics-v2' });
  };

return { __sfc: true,router, chatInput, messages, truncateMessages, sendMessageTask, handleSendMessage, isLoading, goBack, AiChatTextArea, AiChatMessages, AiChatPredefinedMessages, Icon, Tooltip, hasAiBalanceComputed }
}

})